import { render } from "./Vector.vue?vue&type=template&id=32aacd8d"
import script from "./Vector.vue?vue&type=script&lang=js"
export * from "./Vector.vue?vue&type=script&lang=js"

import "./Vector.vue?vue&type=style&index=0&id=32aacd8d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__